import { useLayoutEffect as e, useRef as t, useState as n } from "react";
//#region src/components/CodeBlock/hooks/useIsOverflowing.ts
function r(r, i) {
	let a = t(null), [o, s] = n(!1);
	return e(() => {
		let e = a.current;
		e && s(e.scrollHeight > r + 1);
	}, [r, i]), {
		ref: a,
		overflowing: o
	};
}
//#endregion
export { r as useIsOverflowing };
